import { useForm } from "react-hook-form"
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import InputsFields from "../../helpers/InputFields";
import { initialStateAuth, setCredentials } from "../../store/feautures/AuthSlice";
import { useLoginMutation } from "../../store/services/AuthService";
import { LoginListInput } from "../../utils/listInputs/LoginList";
import Loader from "../main/Loader";
import { injectStyle } from "react-toastify/dist/inject-style";
import { useState } from "react";
import TwoFactorRegistration from "./TwoFactorRegistration";
import TwoFactorForm from "./TwoFactorForm";
import { decodeJwtAndSetCredentials } from "../../utils/decodeJwtAndSetCredentials";

export default function LoginForm() {
    const form = useForm();
    const { handleSubmit } = form;
    const [login, result] = useLoginMutation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [show2FA, setShow2FA] = useState(false);
    const [show2FARegistration, setShow2FARegistration] = useState(false);
    const [userData, setUserData] = useState<any>(null);

    if (typeof window !== "undefined") {
        injectStyle();
    }

    const submitDataForm = async (data: any) => {
        try {
            const userData: any = await login(data).unwrap();

            if (userData.twoFactorRequired) {
                setUserData(userData);

                if (userData.twoFactorRegistrationRequired) {
                    setShow2FARegistration(true); // Mostra QR + OTP
                } else {
                    setShow2FA(true); // Mostra solo OTP
                }
                return;
            }

            // Login senza 2FA: usa la nuova utility
            decodeJwtAndSetCredentials(
            dispatch,
            () => navigate("/dashboard"), // callback onSuccess
            {
                accessToken: userData.accessToken,
                refreshToken: userData.refreshToken,
            },
            "Login completato con successo!", // toast dinamico
            (msg) => toast.error(msg) // gestione errori opzionale
            );

        } catch (error) {
            dispatch(setCredentials(initialStateAuth));
            toast.error(`Ops: controlla le tue credenziali`);
        }
    };

    return (
        <>
            {result?.isLoading && <Loader />}

            {show2FARegistration ? (
                <TwoFactorRegistration
                    userData={userData}
                    onSuccess={() => navigate("/dashboard")}
                />
            ) : show2FA ? (
                <TwoFactorForm
                    userData={userData}
                    onSuccess={() => navigate("/dashboard")}
                />
            ) : (
                <form onSubmit={handleSubmit(submitDataForm)} className="my-12 min-w-full space-y-6">
                    <InputsFields arrFields={LoginListInput} form={form} />
                    <button className="px-6 py-2 w-full mt-4 text-white bg-[#064e3b] rounded-lg text-md">Login</button>
                </form>
            )}
        </>
    );
}
